<framework-assets-image
  [assetFile]="assetFile"
  [size]="size"
  (loaded)="loaded.emit(true)"
  (errored)="errored.emit(true)"
>
  <framework-asset-image-content>
    <div class="left" (click)="openLink()" *ngIf="details">
      <div class="icon-title">
        <mat-icon [ngClass]="project?.status?.id">category</mat-icon>
        <p class="title">{{ project?.name }}</p>
      </div>
      <p class="subtitle">
        {{ project.productType ? project.productType.name + ' •' : null }} {{ project.projectEndDate | date : 'MMM dd,
        YYYY' }}
      </p>
    </div>

    <div class="click" (click)="openLink()"></div>

    <framework-clusted-profile-images
      *ngIf="showMembers === true && project?.members"
      [userList]="project.members"
    ></framework-clusted-profile-images>
  </framework-asset-image-content>
</framework-assets-image>
